module.exports = __webpack_public_path__ + "franchise-ghost_recon-desktop.png";